import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import {
  FaSearch,
  FaChevronLeft,
  FaChevronRight,
  FaRegCalendarAlt,
  FaTimes,
  FaRegClock
} from 'react-icons/fa';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaChevronDown } from "react-icons/fa6";
import * as apicall from '../../components/Apicall';
import Table from '../../components/Table/Table';
import NewAppointment from '../../components/Appointment/NewAppointment';
import { LuClock } from "react-icons/lu";
import { HiOutlineUsers } from "react-icons/hi2";
import { LuClipboardCheck } from "react-icons/lu";
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import VectorBg from '../../assets/images/Vector.svg';
import CustomCalendar from './FullCalendar';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import serviceNames from '../../data/serviceNames.json';
import UserContext from '../../components/context/UserContext'
import ExcelIcon from '../../assets/images/vscode-icons_file-type-excel.svg';
import Skeleton from '../../components/Loader/Skeleton';
import { IoCalendarOutline } from "react-icons/io5";

const timeSlotStyles = {
  dropdownContainer: {
    position: 'relative'
  },
  timeSlotList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    maxHeight: '300px',
    width: '100%',
    overflowY: 'auto',
    zIndex: 1000,
    padding: '12px',
    marginTop: '4px',
    border: '1px solid #E3EBF8',
    boxSizing: 'border-box',
  },
  timeSlotItem: {
    backgroundColor: '#F0F7FF',
    borderRadius: '6px',
    padding: '8px 12px',
    margin: '4px 0',
    cursor: 'pointer',
    fontSize: '12px',
    border: '1px solid #E3EBF8',
    width: '100%',
    textAlign: 'left',
    transition: 'all 0.2s ease',
    color: '#212529',
    '&:hover': {
      backgroundColor: '#E3F2FF',
      borderColor: '#0D6EFD'
    }
  },
  timeSlotItemSelected: {
    backgroundColor: '#E3F2FF',
    border: '1px solid #0D6EFD',
    color: '#0D6EFD'
  },
  timeInput: {
    height: '40px',
    backgroundColor: 'white',
    border: '1px solid #E3EBF8',
    borderRadius: '8px',
    padding: '8px 16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '14px',
    color: '#212529'
  }
};

const chipGridStyles = {
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    justifyContent: 'flex-start',
  },
  chip: {
    display: 'inline-block',
    minWidth: '80px',
    padding: '8px 12px',
    fontSize: '12px',
    textAlign: 'center',
    borderRadius: '14px',
    border: '1px solid #7A5AF8',
    color: '#7A5AF8',
    cursor: 'pointer',
    backgroundColor: '#fff',
    userSelect: 'none',
  },
  chipSelected: {
    backgroundColor: '#7A5AF8',
    color: '#fff',
    fontWeight: '500',
  },
  hiddenCheckbox: {
    display: 'none',
  },
};

const Dashboard = () => {
  const { id: vendorIdFromParams } = useParams();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [appointmentMode, setAppointmentMode] = useState('view');
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [patients, setPatients] = useState([]);
  const [isFetchingPatient, setIsFetchingPatient] = useState(false);
  const [showPatientDropdown, setShowPatientDropdown] = useState(false);
  const [specializations, setSpecializations] = useState([]);
  const [showSpecializationDropdown, setShowSpecializationDropdown] = useState(false);
  const [specializationSearchTerm, setSpecializationSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [appointmentCounts, setAppointmentCounts] = useState({
    total: 0,
    checkedIn: 0,
    pending: 0,
    noShow: 0,
    completed: 0,
    checkedOut: 0
  });
  const [tableData, setTableData] = useState([]);
  const [open, setOpen] = useState(false);
  const [calendarPickerOpen, setCalendarPickerOpen] = useState(false);
  const today = new Date();
  const [dateRange, setDateRange] = useState([today, today]);
  const [tableDateRange, setTableDateRange] = useState([today, today]);
  const [startDate, endDate] = dateRange;
  const [tableStartDate, tableEndDate] = tableDateRange;
  const [calendarDate, setCalendarDate] = useState(today);
  const currentDate = calendarDate.toISOString().split('T')[0];
  const [vendorId, setVendorId] = useState(null)
  const [holidaysDates, setHolidaysDates] = useState([])
  const { vendor, refreshVendorData } = useContext(UserContext);
  const [serviceId, setServiceId] = useState('');

  const [formData, setFormData] = useState({
    mobileNumber: '+971',
    patientName: '',
    age: '',
    dob: '',
    gender: '',
    insuranceNumber: '',
    insuranceProvider: '',
    specialization: '',
    doctorName: '',
    appointmentDate: '',
    dependentId: '',
    selectedTimeSlots: []
  });
  const [dependents, setDependents] = useState([]);
  const [showDependentDropdown, setShowDependentDropdown] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [patientType, setPatientType] = useState('user'); // 'user' or 'dependent'
  const [doctorAvailability, setDoctorAvailability] = useState(null);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [isLoadingSlots, setIsLoadingSlots] = useState(false);
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [calendarAppointmentData, setCalendarAppointmentData] = useState([])
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isDetailsFetched, setIsDetailsFetched] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [doctorDropdownOpen, setDoctorDropdownOpen] = useState(false);
  const [doctorSearchTerm, setDoctorSearchTerm] = useState('');
  const [doctorSearchTimeout, setDoctorSearchTimeout] = useState(null);
  const [appointmentSearchTerm, setAppointmentSearchTerm] = useState('');
  const [doctorPage, setDoctorPage] = useState(1);
  const [hasMoreDoctors, setHasMoreDoctors] = useState(true);
  const [isLoadingMoreDoctors, setIsLoadingMoreDoctors] = useState(false);
  const DOCTORS_PER_PAGE = 30;

  // Add this new state for debounce
  const [searchTimeout, setSearchTimeout] = useState(null);

  const [insuranceProviders, setInsuranceProviders] = useState([]);
  const [showInsuranceProviderDropdown, setShowInsuranceProviderDropdown] = useState(false);
  const [insuranceProviderSearchTerm, setInsuranceProviderSearchTerm] = useState('');

  // Add these refs after other useRef declarations
  const insuranceProviderRef = useRef(null);
  const specializationRef = useRef(null);
  const doctorDropdownRef = useRef(null);
  const appointmentSearchInputRef = useRef(null);

  // Add states for appointment search dropdown
  const [showAppointmentSearchDropdown, setShowAppointmentSearchDropdown] = useState(false);
  const [selectedDoctorForFilter, setSelectedDoctorForFilter] = useState(null);
  const [searchDisplayValue, setSearchDisplayValue] = useState('');

  useEffect(() => {
    const fetchInsuranceProviders = async () => {
      try {
        const response = await apicall.get('insuranceProviders');
        if (response.status === 200) {
          setInsuranceProviders(response.data);
        }
      } catch (error) {
        console.error('Error fetching insurance providers:', error);
        toast.error('Failed to load insurance providers');
      }
    };

    fetchInsuranceProviders();
    refreshVendorData();
  }, []);


  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const getVendorId = () => {
      const vendorIdFromStorage = localStorage.getItem("vendorId");
      return vendorIdFromParams || vendorIdFromStorage;
    };

    const fetchInitialData = (vendorId) => {
      const todayStr = formatDate(new Date());

      setVendorId(vendorId);
      localStorage.setItem("vendorId", vendorId);

      fetchDoctors(vendorId);
      fetchAppointmentDataByRange(todayStr, todayStr, vendorId, false);
      // fetchAppointmentDataByRange(todayStr, todayStr, vendorId, true);
    };

    // Only run this effect when vendorIdFromParams or vendor.id changes
    if (vendor?.id) {
      fetchInitialData(vendor.id);
    } else {
      const vendorId = getVendorId();
      if (vendorId) {
        fetchInitialData(vendorId);
      } else {
        const retryInterval = setInterval(() => {
          const retryVendorId = getVendorId();
          if (retryVendorId) {
            fetchInitialData(retryVendorId);
            clearInterval(retryInterval);
          }
        }, 1000);
        return () => clearInterval(retryInterval);
      }
    }
  }, [vendorIdFromParams, vendor?.id]);

  // Handle date changes separately
  useEffect(() => {
    if (vendorId) {
      const dateStr = formatDate(selectedDate);
      fetchCalendardata(vendorId, dateStr);
    }
  }, [selectedDate, vendorId])

  const fetchSpecializations = useCallback(async (id) => {
    try {
      const response = await apicall.get(`get_service_offerings/${id}`);
      if (response.status === 200) {
        setSpecializations(response.data);
      }
    } catch (error) {
      console.error('Error fetching specializations:', error);
      toast.error('Failed to fetch specializations');
    }
  }, []);

  // Simple serviceId initialization
  useEffect(() => {
    if (vendor?.service_id && !serviceId) {
      setServiceId(vendor.service_id);
      fetchSpecializations(vendor.service);
    }
  }, [vendor, serviceId, fetchSpecializations]);

  // Manual trigger to refresh vendor data if it's null
  useEffect(() => {
    if (!vendor && localStorage.getItem('vendorId')) {
      refreshVendorData();
    }
  }, [vendor, refreshVendorData]);

  // Wait for vendorId to be set in localStorage
  useEffect(() => {
    const checkVendorId = () => {
      const vendorId = localStorage.getItem('vendorId');
      if (vendorId && !vendor) {
        refreshVendorData();
      }
    };

    // Check immediately
    checkVendorId();

    // Set up an interval to check periodically
    const interval = setInterval(checkVendorId, 1000);

    // Clean up interval
    return () => clearInterval(interval);
  }, [vendor, refreshVendorData]);


  const fetchDoctors = async (vendorId, specializationId = '', page = 1, isLoadingMore = false, searchQuery = '') => {
    try {
      if (page === 1) {
        setLoading(true);
      } else {
        setIsLoadingMoreDoctors(true);
      }

      let url = `get_service_providers?vendor_id=${vendorId}&role=5&limit=${DOCTORS_PER_PAGE}&page=${page}`;


      if (specializationId) {
        url += `&specilisation=${specializationId}`;
      }

      if (searchQuery && searchQuery.trim() !== '') {
        url += `&name=${encodeURIComponent(searchQuery.trim())}`;
      }

      const response = await apicall.get(url);


      if (response.status === 200) {
        const formattedDoctors = response.data.map(doctor => ({
          id: doctor.id,
          serviceProvider_id: doctor?.service_provider,
          user_id: doctor.user_id,
          name: `${doctor.first_name} ${doctor.middle_name} ${doctor.last_name}`.trim(),
          specialization: doctor.specilisation // Include specialization from doctor data
        }));

        if (page === 1) {
          setDoctors(formattedDoctors);
        } else {
          setDoctors(prev => [...prev, ...formattedDoctors]);
        }

        setHasMoreDoctors(formattedDoctors.length === DOCTORS_PER_PAGE);
        setDoctorPage(page);
      }
    } catch (error) {
      console.error('Error fetching doctors:', error);
    } finally {
      setLoading(false);
      setIsLoadingMoreDoctors(false);
    }
  };

  //function call to get calendar appointment data

  const fetchCalendardata = useCallback(async (vendorId, date = currentDate) => {
    try {
      setLoading(true);
      const response = await apicall.get(`get_booking_details/${date}/${vendorId}`);
      if (response.status === 200) {
        setCalendarAppointmentData(response.data.filter(item => item.status !== 14));
      }
    } catch (error) {
      console.error('Error fetching appointments:', error);
      toast.error('Failed to fetch appointments');
    } finally {
      setLoading(false);
    }
  }, [currentDate]);



  // Add new function for handling calendar date changes
  const handleCalendarDateChange = (date) => {
    setCalendarDate(date);
    setCalendarPickerOpen(false);
    const formattedDate = date.toISOString().split('T')[0];
    fetchCalendardata(vendorId, formattedDate);
  };

  // Modify the changeDate function
  const changeDate = (direction) => {
    const date = new Date(calendarDate);
    date.setDate(date.getDate() + direction);
    setCalendarDate(date);
    setAppointmentSearchTerm('');

    // Clear any existing search timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Fetch appointments for the new date
    const newDate = date.toISOString().split('T')[0];
    fetchCalendardata(vendorId, newDate);
  };

  const calculateAge = (dob) => {
    if (!dob) return '';
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  //function call to fetch the patient details
  const fetchPatientDetails = async (mobileNumber, setFieldValue) => {
    if (!mobileNumber) return;
    // setSelectedUserId(null)
    try {
      setIsFetchingPatient(true);
      if (patientType === 'user') {
        const response = await apicall.get(`get_patients/${mobileNumber}`);

        if (response.status === 200 && response.data.length > 0) {
          const patient = response.data[0];
          const fullName = `${patient.first_name} ${patient.middle_name || ''} ${patient.last_name || ''}`.trim();
          const age = calculateAge(patient.dob);
          const gender = patient.gender === null ? 'Not Available' : patient.gender === 1 ? 'Male' : 'Female';

          // Update form values using Formik's setFieldValue
          setFieldValue('patientName', fullName);
          setFieldValue('age', age.toString());
          setFieldValue('gender', gender);
          setFieldValue('insuranceNumber', patient.insurance_number || '');
          setFieldValue('insuranceProvider', patient.insurance_provider || '');
          setSelectedUserId(patient.id);

          // Also update formData state for consistency
          setFormData(prev => ({
            ...prev,
            patientName: fullName,
            age: age.toString(),
            gender: gender
          }));

          // Set details as fetched
          setIsDetailsFetched(true);
        } else {
          setFieldValue('patientName', "");
          setFieldValue('age', "");
          setFieldValue('gender', "");
          setFieldValue('insuranceNumber', '');
          setFieldValue('insuranceProvider', '');
          setSelectedUserId(null);
        }
      } else {
        // For dependents, first get the user ID
        const userResponse = await apicall.get(`get_patients/${mobileNumber}`);
        if (userResponse.status === 200 && userResponse.data.length > 0) {
          const userId = userResponse.data[0].id;
          setSelectedUserId(userId);

          // Then fetch dependents for this user
          const dependentsResponse = await apicall.get(`/dependents/${userId}`);
          if (dependentsResponse.status === 200 && dependentsResponse.data) {
            const formattedDependents = dependentsResponse.data.map(dependent => ({
              id: dependent.id,
              name: dependent.name,
              gender: dependent.gender === 1 ? 'Male' : 'Female',
              phoneNumber: dependent.mobile_number,
              dob: dependent.dob
            }));

            setDependents(formattedDependents);
            setShowDependentDropdown(true);
            // Don't set isDetailsFetched for dependents until one is selected
          }
        }
      }
    } catch (error) {
      console.error('Error fetching details:', error);
      toast.error('Failed to fetch patient details');
    } finally {
      setIsFetchingPatient(false);
    }
  };

  //function call to fetch the avilable slots
  const fetchDoctorAvailability = async (doctorId, selectedDate) => {
    if (!doctorId || !selectedDate) return;

    try {
      setIsLoadingSlots(true);
      setShowTimeDropdown(false);

      // Format the date to YYYY-MM-DD format
      const formattedDate = new Date(selectedDate).toISOString().split('T')[0];
      const response = await apicall.get(`get_available_slots/${doctorId}/${formattedDate}`);

      if (response && response.data) {
        const { available_slots, appointment_duration, no_of_slots } = response.data;

        // Update doctor availability info
        setDoctorAvailability({
          appointment_duration,
          no_of_slots
        });

        // Update available time slots
        setAvailableTimeSlots(available_slots || []);
      } else {
        setAvailableTimeSlots([]);
        setDoctorAvailability(null);
      }
    } catch (error) {
      console.error('Error fetching doctor availability:', error);
      toast.error('Failed to fetch available slots');
      setAvailableTimeSlots([]);
      setDoctorAvailability(null);
    } finally {
      setIsLoadingSlots(false);
    }
  };

  //function call to handle on change of the patient
  const handlePatientTypeChange = (e) => {
    const type = e.target.value;
    setPatientType(type);
    setIsDetailsFetched(false); // Reset fetched state when type changes
    setFormData({
      mobileNumber: '',
      patientName: '',
      age: '',
      dob: '',
      gender: '',
      insuranceNumber: '',
      insuranceProvider: '',
      specialization: '',
      doctorName: '',
      appointmentDate: '',
      selectedTimeSlots: []
    });
    setPatients([]);
    setDependents([]);
    setShowPatientDropdown(false);
    setShowDependentDropdown(false);

  };

  const handleDependentSelect = (dependent, setFieldValue) => {
    const age = calculateAge(dependent.dob);
    setFieldValue('patientName', dependent.name);
    setFieldValue('gender', dependent.gender);
    setFieldValue('dependentId', dependent.id);
    setFieldValue('age', age.toString());
    setIsDetailsFetched(true);
    setShowDependentDropdown(false);
  };

  const timeSlotRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (timeSlotRef.current && !timeSlotRef.current.contains(event.target)) {
        setShowTimeDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  //function call to add event color with respect to the status
  const getStatusColors = (status) => {
    // Define color schemes for different statuses with requested light colors
    const statusColors = {
      // Pending/Upcoming (10) - Light yellow
      10: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000"
      },
      // Checked In (11) - Light blue
      11: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E"
      },
      // Cancelled (14) - Light red
      14: {
        bgColor: "rgba(255, 204, 204, 0.5)",
        borderColor: "#CC0000",
        textColor: "#990000"
      },
      // No Show (12) - Light orange
      12: {
        bgColor: "F2F9FF",
        borderColor: "#037FE8",
        textColor: "#037FE8"
      },
      // Completed/Checked Out (15) - Light green
      15: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600"
      },
      // Default - Light gray
      default: {
        bgColor: "rgba(230, 230, 230, 0.5)",
        borderColor: "#999999",
        textColor: "#666666"
      }
    };

    return statusColors[status] || statusColors.default;
  };

  // Helper function to format booking time into FullCalendar date format
  const toFullCalendarDate = (bookingDate, bookingTime) => {
    return `${bookingDate}T${bookingTime}:00`; // Assuming bookingTime is in 'HH:mm' format
  };

  const addMinutes = (timeStr, minutesToAdd) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours, minutes + minutesToAdd, 0, 0);
    return date.toTimeString().slice(0, 5); // "HH:mm"
  };

  // Convert calendar appointment data to FullCalendar events
  const appointments = calendarAppointmentData.map((item) => {
    const colors = getStatusColors(item?.status);
    const sortedSlots = [...item.time_slots].sort();
    const start = toFullCalendarDate(item.booking_date, sortedSlots[0]);
    const totalDuration = item.appointment_duration * item.time_slots.length;
    const endTime = addMinutes(sortedSlots[0], totalDuration);
    const end = toFullCalendarDate(item.booking_date, endTime);


    return {
      title: `${item.doctor_name.trim()} | ${item.specialization}`,
      search: item.doctor_name.trim(),
      start,
      end,
      backgroundColor: colors.bgColor,
      borderColor: colors.borderColor,
      textColor: colors.textColor,
      extendedProps: {
        ...item,
      },
      // Optional: Add event class for additional styling
      className: `status-${item?.status || 'default'}`
    };
  });

  //function call to convert date to 12 hours 
  const convertTo12Hour = (time24) => {
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // Convert 0 to 12
    return `${hour}:${minute} ${ampm}`;
  }

  //function call to on click to set set the appointment details into the side menu
  const handleAppointmentClick = (appointment, currentDate) => {
    setSelectedAppointment({
      patientName: appointment?.details?.patient_name,
      age: appointment?.details?.patient_age,
      gender: appointment?.details?.patient_gender === 1 ? 'Male' : 'Female',
      mobileNumber: appointment?.details?.doctor_phone,
      insuranceNumber: appointment?.details?.insurance_number,
      service_provider: appointment?.details?.service_provider,
      doctorName: appointment?.details?.doctor_name,
      appointmentDate: appointment?.details?.booking_date,
      appointmentTime: convertTo12Hour(appointment?.details?.booking_time),
      bookingId: appointment?.details?.id,
      details: appointment?.details
    });
    fetchDoctorAvailability(appointment?.details?.doctor_id, currentDate);
    fetchDoctorHolidays(appointment?.details?.doctor_id)
    setAppointmentMode('view');
  };

  const refreshOverviewTiles = () => {
    if (vendorId) {
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      // Use current date range or default to today
      const currentStartDate = startDate || new Date();
      const currentEndDate = endDate || new Date();
      const startDateStr = formatDate(currentStartDate);
      const endDateStr = formatDate(currentEndDate);

      // Fetch data for overview tiles (isTableView = false)
      fetchAppointmentDataByRange(startDateStr, endDateStr, vendorId, false);
    }
  };

  const handleCloseAppointment = (nextMode) => {
    if (nextMode === 'edit') {
      setAppointmentMode('edit');
    } else {
      setSelectedAppointment(null);
      setAppointmentMode('view');
      fetchCalendardata(vendorId);
      refreshOverviewTiles(); // Refresh overview tiles after appointment changes
    }
  };

  // Add useEffect to refresh tiles when calendar data changes
  useEffect(() => {
    if (calendarAppointmentData.length > 0) {
      refreshOverviewTiles();
    }
  }, [calendarAppointmentData]);

  //function call for the yup formik validation

  const validationSchema = Yup.object({
    mobileNumber: Yup.string()
      .required('Contact number is required')
      .matches(/^[0-9]+$/, 'Contact number is required')
      .test('country-specific-length', 'Invalid phone number length', function (value) {
        if (!value) return true;
        // Remove any non-digit characters
        const cleanedValue = value.replace(/\D/g, '');
        // Check for India
        if (cleanedValue.startsWith('91')) {
          if (cleanedValue.length < 12) {
            return this.createError({ message: 'Please enter a valid Indian phone number (min 10 digits)' });
          }
          return true;
        }
        // Check for UAE
        if (cleanedValue.startsWith('971')) {
          if (cleanedValue.length < 12) {
            return this.createError({ message: 'Please enter a valid UAE phone number (min 9 digits)' });
          }
          return true;
        }
        // For other numbers, provide a generic message
        return this.createError({ message: 'Please enter a valid phone number' });
      }),
    patientName: Yup.string()
      .required('Patient name is required')
      .min(2, 'Name must be at least 2 characters')
      .max(50, 'Name must not exceed 50 characters'),
    ...(
      // Case 1: New patient (no selectedUserId)
      selectedUserId === null
        ? {
          dob: Yup.string()
            .required('Date of Birth is required')
            .test('valid-dob', 'Invalid Date of Birth', (value) => {
              if (!value) return false;
              const dob = new Date(value);
              const today = new Date();
              return dob < today; // Ensure DOB is in the past
            }),
        }
        : // Case 2: Existing user or dependent (selectedUserId exists)
        (patientType === "user" || (patientType === "dependent" && dependents.length !== 0))
          ? {
            // Check if age field is shown or DOB field is shown
            dob: Yup.string()
              .when('age', {
                is: (age) => !age || age === '',
                then: (schema) => schema
                  .required('Date of Birth is required')
                  .test('valid-dob', 'Invalid Date of Birth', (value) => {
                    if (!value) return false;
                    const dob = new Date(value);
                    const today = new Date();
                    return dob < today;
                  }),
                otherwise: (schema) => schema.notRequired(),
              }),
          }
          : // Case 3: New dependent (no selectedUserId and no existing dependents)
          {
            dob: Yup.string()
              .required('Date of Birth is required for new dependents')
              .test('valid-dob', 'Invalid Date of Birth', (value) => {
                if (!value) return false;
                const dob = new Date(value);
                const today = new Date();
                return dob < today;
              }),
          }
    ),
    gender: Yup.string()
      .required('Gender is required')
      .oneOf(['Male', 'Female'], 'Please select a valid gender'),
    insuranceNumber: Yup.string()
      .when('insuranceProvider', {
        is: (val) => val && val.length > 0,
        then: (schema) => schema.required('Insurance number is required when provider is selected'),
        otherwise: (schema) => schema.notRequired(),
      }),
    insuranceProvider: Yup.string(),
    doctorName: Yup.string()
      .required('Please select a doctor'),
    appointmentDate: Yup.string()
      .required('Please select a date'),
    selectedTimeSlots: Yup.array()
      .min(1, 'Select at least one time slot')
      .required('Time slot is required'),
  });

  // Function to fetch appointment data based on date range
  const fetchAppointmentDataByRange = async (startDate, endDate, vendorId, isTableView = false) => {
    if (!vendorId) {
      console.error('Vendor ID is required');
      return;
    }

    try {
      setLoading(true);
      const response = await apicall.get(`get_booking_details/range/${startDate}/${endDate}/${vendorId}`);

      if (response.status === 200) {
        const allData = response.data;

        if (isTableView) {
          // Format the data for the table
          const formattedData = allData.map((item, index) => [
            index + 1,
            item.patient_name,
            item.doctor_name,
            convertTo12Hour(item.booking_time),
            item.booking_date,
            getStatusText(item.status, item.booking_date, item.booking_time),
            item.patient_age || '',
            item.patient_gender === 1 ? 'Male' : 'Female',
            item.patient_phone || '',
            item.id,
            item.status,
            item.user_id,
            item.doctor_id,
            item.insurance_provider,
            item.insurance_number
          ]);

          setTableData(formattedData);
        } else {
          // Update counts for overview
          const counts = {
            total: allData.length,  // This gives us the total count of all appointments
            checkedIn: allData.filter(item => item.status === 11).length,
            pending: allData.filter(item => {
              if (item.status === 10) {
                const appointmentDateTime = new Date(`${item.booking_date}T${item.booking_time}`);
                const currentDateTime = new Date();
                return appointmentDateTime < currentDateTime;
              }
              return false;
            }).length,
            noShow: allData.filter(item => item.status === 12).length,
            completed: allData.filter(item => {
              if (item.status === 10) {
                const appointmentDateTime = new Date(`${item.booking_date}T${item.booking_time}`);
                const currentDateTime = new Date();
                return appointmentDateTime >= currentDateTime;
              }
              return false;
            }).length,
            checkedOut: allData.filter(item => item.status === 15).length
          };

          setAppointmentCounts(counts);
        }
      }
    } catch (error) {
      console.error('Error fetching appointment data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (update, isTableView = false) => {
    if (isTableView) {
      setTableDateRange(update);
      if (update[0]) {
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const selectedDate = formatDate(update[0]);
        let endDateStr = selectedDate;

        if (update[1]) {
          endDateStr = formatDate(update[1]);
          setOpen(false);
        }

        // Fetch data for the table view
        fetchAppointmentDataByRange(selectedDate, endDateStr, vendorId, true);
      }
    } else {
      setDateRange(update);
      if (update[0]) {
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const selectedDate = formatDate(update[0]);
        let endDateStr = selectedDate;

        if (update[1]) {
          endDateStr = formatDate(update[1]);
          setOpen(false);
        }

        // Fetch data for the overview section
        fetchAppointmentDataByRange(selectedDate, endDateStr, vendorId, false);
      }
    }
  };

  const formatDateDisplay = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Add a function to handle tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Don't reset date ranges - maintain the current selection
    setOpen(false);
    setCalendarPickerOpen(false);

    // If switching to table view, use the current overview date range
    if (tab === 'table' && vendorId) {
      const formatDate = (date) => {
        if (!date) {
          const today = new Date();
          return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      // Use the current overview date range or default to today if not set
      const currentStartDate = startDate || new Date();
      const currentEndDate = endDate || new Date();

      // Update table date range to match overview date range
      setTableDateRange([currentStartDate, currentEndDate]);

      // Format dates for API call
      const startDateStr = formatDate(currentStartDate);
      const endDateStr = formatDate(currentEndDate);

      // Fetch data for the table view with the same date range
      fetchAppointmentDataByRange(startDateStr, endDateStr, vendorId, true);
    }
  };

  // Helper function to get status text
  const getStatusText = (status, bookingDate, bookingTime) => {
    // For active appointments (status 10), check if it's in the future
    if (status === 10) {
      const appointmentDateTime = new Date(`${bookingDate}T${bookingTime}`);
      const currentDateTime = new Date();

      if (appointmentDateTime >= currentDateTime) {
        return 'Active';
      }
      return 'Pending';
    }

    switch (status) {
      case 11: return 'Checked In';
      case 12: return 'No Show';
      case 15: return 'Completed';
      default: return 'Unknown';
    }
  };

  // Helper function to get status badge styles
  const getStatusBadgeClass = (status) => {
    const baseStyles = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '26px',
      borderRadius: '20px',
      borderWidth: '1px',
      padding: '4px 16px',
      gap: '10px',
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '1',
      whiteSpace: 'nowrap'
    };

    switch (status.toLowerCase()) {
      case 'active':
        return {
          ...baseStyles,
          backgroundColor: '#FFEBEE',
          border: '1px solid #D32F2F',
          width: '86px',
          color: '#D32F2F'
        };

      case 'pending':
        return {
          ...baseStyles,
          backgroundColor: '#FFF3E0',
          border: '1px solid #FB8C00',
          width: '86px',
          color: '#FB8C00'
        };

      case 'no show':
        return {
          ...baseStyles,
          backgroundColor: '#E3F2FD',
          border: '1px solid #1976D2',
          width: '88px',
          color: '#1976D2'
        };

      case 'checked in':
        return {
          ...baseStyles,
          backgroundColor: '#F3E5F5',
          border: '1px solid #8E24AA',
          width: '90px',
          color: '#8E24AA'
        };

      case 'completed':
        return {
          ...baseStyles,
          backgroundColor: '#FFF9C4',
          border: '1px solid #FBC02D',
          width: '100px',
          color: '#795548'
        };

      default:
        return {
          ...baseStyles,
          backgroundColor: '#F5F5F5',
          border: '1px solid #E0E0E0',
          color: '#000000'
        };
    }

  };

  // Update the overview card click handler
  const renderOverview = () => (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4 pt-4">
        <div>
          <h5 className="mb-0" style={{ fontSize: '18px', fontWeight: '600' }}>
            Overview
            {startDate && (
              <span style={{ fontSize: '14px', fontWeight: '400', marginLeft: '8px', color: '#6C757D' }}>
                ({formatDateDisplay(startDate)}
                {endDate && startDate.getTime() !== endDate.getTime() ? ` - ${formatDateDisplay(endDate)}` : ''})
              </span>
            )}
          </h5>
        </div>
        <div className="d-flex align-items-center gap-2" style={{ position: 'relative' }}>
          <span style={{ fontSize: '14px', color: '#000' }}>Filter by:</span>
          <div style={{ position: 'relative' }}>
            <button
              className="btn btn-light d-flex align-items-center justify-content-center"
              style={{ width: '32px', height: '32px', padding: 0, border: '1px solid #E3EBF8' }}
              onClick={() => setOpen(!open)}
            >
              <FaRegCalendarAlt size={14} />
            </button>
            {open && (
              <div style={{ position: 'absolute', top: '40px', right: 0, zIndex: 9999 }}>
                <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => handleDateChange(update, false)}
                  inline
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 mb-4">
        {[
          {
            label: <strong>Appointment</strong>,
            value: appointmentCounts.total,
            icon: <LuClock style={{ fontSize: '20px', color: '#FF0000' }} />,
            bgColor: '#FDEDED',
            tab: 'table',
            status: 'All'
          },
          {
            label: <strong>Checked In</strong>,
            value: appointmentCounts.checkedIn,
            icon: <LuClipboardCheck style={{ fontSize: '20px', color: '#92007E' }} />,
            bgColor: '#FFF0FD',
            tab: 'table',
            status: 'Checked In'
          },
          {
            label: <strong>Pending</strong>,
            value: appointmentCounts.pending,
            icon: <HiOutlineUsers style={{ fontSize: '20px', color: '#C75C2C' }} />,
            bgColor: '#FFF0E0',
            tab: 'table',
            status: 'Pending'
          },
          {
            label: <strong>No Show</strong>,
            value: appointmentCounts.noShow,
            icon: <HiOutlineUsers style={{ fontSize: '20px', color: '#037FE8' }} />,
            bgColor: '#F2F9FF',
            tab: 'table',
            status: 'No show'
          }
        ].map((item, index) => (
          <div className="col" key={index}>
            <div
              className="card d-flex flex-row align-items-center p-3"
              style={{
                cursor: 'pointer',
                borderRadius: '12px',
                height: '90px',
                border: '1px solid #E3EBF8',
              }}
              onClick={() => {
                setStatusFilter(item.status);
                handleTabChange(item.tab);
              }}
            >
              <div
                style={{
                  backgroundColor: item.bgColor,
                  borderRadius: '50%',
                  width: '48px',
                  height: '48px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                }}
              >
                {item.icon}
              </div>
              <div>
                <div style={{ fontSize: '14px', color: '#212529', marginBottom: '4px' }}>
                  {item.label}
                </div>
                <h5 style={{ fontSize: '18px', fontWeight: '700', margin: 0 }}>{item.value}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  // Update the table view back button handler
  const renderTableView = () => {
    const headers = ['Sl. No', 'Patient Name', 'Doctor', 'Time Slot', 'Date', 'Status'];
    const exportHeaders = ['Sl. No', 'Patient Name', 'Doctor', 'Time Slot', 'Date', 'Status', 'Age', 'Gender', 'Phone Number'];

    // Filter the table data based on status
    const filteredTableData = tableData.filter(row => {
      const status = row[5]; // Status is in the 6th column

      switch (statusFilter) {
        case 'All':
          return true;
        case 'Active':
          return status === 'Active';
        case 'Pending':
          return status === 'Pending';
        case 'Completed':
          return status === 'Completed';
        case 'No show':
          return status === 'No Show';
        case 'Checked In':
          return status === 'Checked In';
        default:
          return true;
      }
    });

    const customFilters = (
      <div className="d-flex align-items-center gap-2 position-relative flex-wrap">
        {/* Filter by: Date Range */}
        <span style={{ fontSize: '14px', color: '#000', fontWeight: '600' }}>Filter by:</span>
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn d-flex align-items-center gap-2 px-3"
            style={{
              height: '40px',
              fontSize: '14px',
              borderRadius: '6px',
              backgroundColor: '#FFFFFF',
              border: '1px solid #E3EBF8',
              color: '#000000',
            }}
            onClick={() => {
              setOpen(!open);
              setCalendarPickerOpen(false); // close other calendar picker if any
            }}
          >
            {tableStartDate ? (
              tableEndDate && tableStartDate.getTime() !== tableEndDate.getTime()
                ? `${formatDateDisplay(tableStartDate)} - ${formatDateDisplay(tableEndDate)}`
                : formatDateDisplay(tableStartDate)
            ) : 'Date'} <FaRegCalendarAlt />
          </button>

          {open && (
            <div
              style={{
                position: 'absolute',
                top: '45px',
                left: '0',
                zIndex: 9999,
                backgroundColor: '#fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                borderRadius: '8px',
              }}
            >
              <DatePicker
                selectsRange
                startDate={tableStartDate}
                endDate={tableEndDate}
                onChange={(update) => handleDateChange(update, true)}
                inline
              />
            </div>
          )}
        </div>

        {/* Sort by Status */}
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span style={{ fontSize: '14px', color: '#000', fontWeight: '600' }}>Sort by:</span>
          <div className="btn-group">
            {['All', 'Active', 'Pending', 'Completed', 'No show', 'Checked In'].map((label) => (
              <button
                key={label}
                className={`btn px-3 ${statusFilter === label ? 'btn-primary' : ''}`}
                style={{
                  height: '40px',
                  fontSize: '14px',
                  borderRadius: '8px',
                  marginRight: '10px',
                  backgroundColor: statusFilter === label ? '#FFF7F9' : '#FFFFFF',
                  border: statusFilter === label ? '1px solid #C9194A' : '1px solid #E3EBF8',
                  color: '#000000',
                }}
                onClick={() => {
                  setStatusFilter(label);
                  setCurrentPage(1); // Reset pagination
                }}
              >
                {label}
              </button>
            ))}
          </div>
          <button
            className="btn px-3"
            style={{
              height: '40px',
              fontSize: '14px',
              borderRadius: '8px',
              backgroundColor: '#FFFFFF',
              border: '1px solid #E3EBF8',
              color: '#000000',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
            onClick={() => {
              // Create CSV content with Age, Gender, Phone Number (export only)
              const csvContent = [
                exportHeaders.join(','),
                ...filteredTableData.map(row => [
                  row[0], // Sl. No
                  row[1], // Patient Name
                  row[2], // Doctor
                  row[3], // Time Slot
                  row[4], // Date
                  row[5], // Status
                  row[6], // Age
                  row[7], // Gender
                  row[8]  // Phone Number
                ].join(','))
              ].join('\n');

              // Create and trigger download
              const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
              const link = document.createElement('a');
              const url = URL.createObjectURL(blob);
              link.setAttribute('href', url);
              link.setAttribute('download', `appointments_${new Date().toISOString().split('T')[0]}.csv`);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            <img src={ExcelIcon} alt="Excel" style={{ width: '20px', height: '20px' }} />
            Export
          </button>
        </div>
      </div>
    );


    return (

      <Table
        title="Appointments"
        headers={headers}
        data={filteredTableData.map(row =>
          row.map(cell =>
            typeof cell === 'string'
              ? cell.charAt(0).toUpperCase() + cell.slice(1)
              : cell
          )
        )}
        loading={loading}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onBackClick={() => handleTabChange('dashboard')}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
        customFilters={customFilters}
        getStatusBadgeClass={getStatusBadgeClass}
      />
    );
  };

  // Update the calendar view date picker button click handler
  const handleCalendarDateButtonClick = () => {
    setCalendarPickerOpen(!calendarPickerOpen);
    setOpen(false); // Close the table view date picker
  };

  //function call to convert the time slots to 24 hours format
  const convertSlotsTo24HourFormat = (slots) => {
    return slots.map(slot => {
      const [time, modifier] = slot.trim().split(' ');
      let [hours, minutes] = time.split(':');
      hours = parseInt(hours, 10);

      if (modifier.toUpperCase() === 'PM' && hours < 12) hours += 12;
      if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;

      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    });
  };

  //api function to handle the book appointment
  const handleBookAppointmentApi = async (payload) => {
    try {
      const response = await apicall.post(payload, 'book-appointment');

      if (response.status === 200) {
        toast.success('Appointment booked successfully');
        setFormData({
          mobileNumber: '',
          patientName: '',
          age: '',
          gender: '',
          insuranceNumber: '',
          insuranceProvider: '',
          specialization: '',
          doctorName: '',
          appointmentDate: '',
          selectedTimeSlots: []
        });
        fetchCalendardata(vendorId);
      } else {
        console.log("response", response.message);
      }
    } catch (error) {
      console.error('Error creating availability:', error);
      toast.error(error?.message || 'Failed to book appointment');
    }
  };

  //function call to fetch available slots
  const getDatesInRange = (startDateStr, endDateStr) => {
    const dates = [];

    // Extract just the date parts (YYYY-MM-DD)
    const startDateOnly = startDateStr.split(' ')[0];
    const endDateOnly = endDateStr.split(' ')[0];

    // Parse dates without timezone considerations
    const [startYear, startMonth, startDay] = startDateOnly.split('-').map(Number);
    const [endYear, endMonth, endDay] = endDateOnly.split('-').map(Number);

    const start = new Date(startYear, startMonth - 1, startDay);
    const end = new Date(endYear, endMonth - 1, endDay);

    let current = new Date(start);
    while (current <= end) {
      // Format as YYYY-MM-DD using local date components
      const dateStr = [
        current.getFullYear(),
        String(current.getMonth() + 1).padStart(2, '0'),
        String(current.getDate()).padStart(2, '0')
      ].join('-');

      dates.push(dateStr);
      current.setDate(current.getDate() + 1);
    }

    return dates;
  };

  //function call to handle to get the holidays of the doctor

  const fetchDoctorHolidays = async (doctorId) => {
    try {
      const response = await apicall.get(`get_holidays?user_id=${doctorId}`);
      if (response.status === 200) {
        const allHolidayDates = response.data.flatMap(holiday =>
          getDatesInRange(holiday.holiday_start, holiday.holiday_end)
        );
        // Remove duplicates and sort
        const uniqueUnavailableDates = [...new Set(allHolidayDates)].sort();
        setHolidaysDates(uniqueUnavailableDates);
      } else {
        console.log("response", response.message);
      }
    } catch (error) {
      console.error('Error fetching holidays:', error);
      toast.error('Failed to fetch holidays');
    }
  };

  const normalize = (str) => str.toLowerCase().replace(/\s+/g, ' ').trim();
  const filteredAppointments = appointments.filter(appointment => {
    if (!appointmentSearchTerm) return true;
    return normalize(appointment.search).includes(normalize(appointmentSearchTerm));
  });


  // Add cleanup for search timeout
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  // Get service name based on service_id
  const getServiceName = (names) => {
    const service = serviceNames.service_names.find(s => s.service_id === Number(serviceId)); // Default to 7 for doctors
    return service ? service[names] : '';
  };

  // Add this useEffect after other useEffect declarations
  useEffect(() => {
    function handleClickOutside(event) {
      // Handle Insurance Provider dropdown
      if (insuranceProviderRef.current && !insuranceProviderRef.current.contains(event.target)) {
        setShowInsuranceProviderDropdown(false);
      }

      // Handle Specialization dropdown
      if (specializationRef.current && !specializationRef.current.contains(event.target)) {
        setShowSpecializationDropdown(false);
      }

      // Handle Doctor dropdown
      if (doctorDropdownRef.current && !doctorDropdownRef.current.contains(event.target)) {
        setDoctorDropdownOpen(false);
      }

      // Handle Appointment Search dropdown - check if click is outside the entire search container
      if (appointmentSearchInputRef.current) {
        const searchContainer = appointmentSearchInputRef.current.parentElement;
        if (searchContainer && !searchContainer.contains(event.target)) {
          setShowAppointmentSearchDropdown(false);
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  // Function to filter appointments by selected doctor
  const filterAppointmentsByDoctor = async (doctorId) => {
    try {
      const response = await apicall.get(`get_booking_details/${currentDate}/${vendorId}?doctor_id=${doctorId}`);
      if (response.status === 200) {
        const filteredData = response.data.filter(item => item.status !== 14);
        setCalendarAppointmentData(filteredData);
      }
    } catch (error) {
      console.error('Error filtering appointments by doctor:', error);
      toast.error('Failed to filter appointments');
    }
  };

  return (
    <div className="container-fluid">
      {/* Show skeleton loader while vendor data is loading */}
      {!vendor ? (
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-4 pt-4">
            <Skeleton width="200px" height="24px" />
            <Skeleton width="150px" height="32px" />
          </div>

          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 mb-4">
            {[1, 2, 3, 4].map((item) => (
              <div className="col" key={item}>
                <div className="card d-flex flex-row align-items-center p-3" style={{ borderRadius: '12px', height: '90px', border: '1px solid #E3EBF8' }}>
                  <Skeleton width="48px" height="48px" marginBottom="0" style={{ borderRadius: '50%', marginRight: '16px' }} />
                  <div style={{ flex: 1 }}>
                    <Skeleton width="80px" height="16px" marginBottom="4px" />
                    <Skeleton width="40px" height="24px" marginBottom="0" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-12 col-xl-8">
              <Skeleton width="200px" height="24px" marginBottom="16px" />
              <div className="d-flex justify-content-between align-items-center mb-4">
                <Skeleton width="240px" height="40px" />
                <div className="d-flex gap-2">
                  <Skeleton width="32px" height="32px" />
                  <Skeleton width="64px" height="32px" />
                  <Skeleton width="32px" height="32px" />
                  <Skeleton width="32px" height="32px" />
                </div>
              </div>
              <div className="card border-0">
                <div className="card-body p-0">
                  <Skeleton width="100%" height="720px" />
                </div>
              </div>
            </div>

            <div className="col-12 col-xl-4">
              <div className="card border-0 rounded-2" style={{ marginTop: '2.5rem' }}>
                <div className="bg-primary px-4 py-3 border-bottom border-white">
                  <Skeleton width="150px" height="24px" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
                </div>
                <div className="card-body p-4" style={{ backgroundColor: '#0D6EFD', minHeight: '600px' }}>
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                    <div key={item} className="mb-3">
                      <Skeleton width="100px" height="16px" marginBottom="8px" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
                      <Skeleton width="100%" height="40px" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
                    </div>
                  ))}
                  <div className="d-flex gap-2">
                    <Skeleton width="50%" height="40px" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
                    <Skeleton width="50%" height="40px" style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {activeTab !== 'dashboard' ? (
            renderTableView()
          ) : (
            <>
              {renderOverview()}
              <div className="row">
                <div className="col-12 col-xl-8">
                  <h5 className="mb-2">Appointment Schedule</h5>

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="position-relative">
                      <input
                        ref={appointmentSearchInputRef}
                        type="text"
                        className="form-control"
                        placeholder={`Search for ${getServiceName('name')}`}
                        onChange={(e) => {
                          const value = e.target.value;
                          setSearchDisplayValue(value);
                          setAppointmentSearchTerm(value);

                          // Clear any existing timeout
                          if (searchTimeout) {
                            clearTimeout(searchTimeout);
                          }

                          // If search is cleared, fetch all appointments and hide dropdown
                          if (value.length === 0) {
                            setShowAppointmentSearchDropdown(false);
                            setSelectedDoctorForFilter(null);
                            fetchCalendardata(vendorId, currentDate);
                            return;
                          }

                          // Search for doctors if 1 character or more (for dynamic auto-fill)
                          if (value.length >= 1) {
                            setShowAppointmentSearchDropdown(true);
                            const timeoutId = setTimeout(() => {
                              // Use fetchDoctors to search for doctors starting with the search term
                              fetchDoctors(vendorId, '', 1, false, value);
                            }, 300); // Reduced debounce time for better responsiveness
                            setSearchTimeout(timeoutId);
                          }
                        }}
                        onFocus={() => {
                          if (searchDisplayValue.length >= 1) {
                            setShowAppointmentSearchDropdown(true);
                          }
                        }}
                        style={{
                          height: '40px',
                          width: '240px',
                          backgroundColor: '#F8F9FA',
                          border: '1px solid #E3EBF8',
                          borderRadius: '8px',
                          paddingLeft: '36px',
                          fontSize: '14px'
                        }}
                      />
                      <FaSearch
                        className="position-absolute text-muted fs-14"
                        style={{ left: '12px', top: '12px' }}
                      />
                      {searchDisplayValue && (
                        <button
                          className="btn btn-link position-absolute p-0"
                          onClick={() => {
                            if (appointmentSearchInputRef.current) {
                              appointmentSearchInputRef.current.value = '';
                            }
                            setSearchDisplayValue('');
                            setAppointmentSearchTerm('');
                            setShowAppointmentSearchDropdown(false);
                            setSelectedDoctorForFilter(null);
                            fetchCalendardata(vendorId, currentDate);
                          }}
                          style={{
                            right: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#6C757D',
                            cursor: 'pointer',
                            fontSize: '20px'
                          }}
                        >
                          <FaTimes size={14} />
                        </button>
                      )}

                      {/* Doctor Search Dropdown */}
                      {showAppointmentSearchDropdown && doctors.length > 0 && (
                        <div
                          className="position-absolute bg-white border rounded shadow-sm"
                          style={{
                            top: '100%',
                            left: 0,
                            right: 0,
                            zIndex: 1000,
                            maxHeight: '200px',
                            overflowY: 'auto',
                            marginTop: '4px'
                          }}
                        >
                          {doctors.map((doctor) => (
                            <div
                              key={doctor.id}
                              className="p-2 cursor-pointer hover-bg-light"
                              style={{
                                borderBottom: '1px solid #dee2e6',
                                cursor: 'pointer'
                              }}
                              onClick={() => {
                                setSelectedDoctorForFilter(doctor);

                                const doctorNameOnly = doctor.name.charAt(0).toUpperCase() + doctor.name.slice(1).toLowerCase();
                                // Directly set the input value without triggering onChange
                                if (appointmentSearchInputRef.current) {
                                  appointmentSearchInputRef.current.value = doctorNameOnly;
                                }
                                setSearchDisplayValue(doctorNameOnly);
                                setAppointmentSearchTerm(doctorNameOnly);
                                setShowAppointmentSearchDropdown(false);
                                // Filter appointments for this doctor
                                filterAppointmentsByDoctor(doctor.id);
                              }}
                            >
                              {`${getServiceName("shortName")}. ${doctor.name.charAt(0).toUpperCase()}${doctor.name.slice(1).toLowerCase()}`}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <button className="btn btn-light d-flex align-items-center justify-content-center"
                        style={{ width: '32px', height: '32px', padding: 0, border: '1px solid #E3EBF8' }}
                        onClick={() => changeDate(-1)}
                      >
                        <FaChevronLeft size={14} />
                      </button>
                      <button className="btn btn-dark d-flex align-items-center justify-content-center"
                        style={{ width: '64px', height: '32px', padding: 0, fontSize: '14px' }}>
                        {calendarDate.toDateString() === new Date().toDateString()
                          ? 'Today'
                          : calendarDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                      </button>
                      <button className="btn btn-light d-flex align-items-center justify-content-center"
                        style={{ width: '32px', height: '32px', padding: 0, border: '1px solid #E3EBF8' }}
                        onClick={() => changeDate(1)}
                      >
                        <FaChevronRight size={14} />
                      </button>
                      <button className="btn btn-light d-flex align-items-center justify-content-center"
                        style={{ width: '32px', height: '32px', padding: 0, border: '1px solid #E3EBF8' }}
                        onClick={handleCalendarDateButtonClick}
                      >
                        <FaRegCalendarAlt size={14} />
                      </button>
                      {calendarPickerOpen && (
                        <div style={{ position: 'absolute', top: '45px', zIndex: 9999 }}>
                          <DatePicker
                            key={calendarDate.toString()}
                            openToDate={calendarDate}
                            selected={calendarDate}
                            onChange={handleCalendarDateChange}
                            inline
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="card border-0">
                    <div className="card-body p-0 border-box	">
                      <div className="position-relative" style={{ minHeight: '720px' }}>
                        <CustomCalendar events={filteredAppointments} date={currentDate} onAppointmentClick={handleAppointmentClick} startTime={vendor?.working_hours_start} endTime={vendor?.working_hours_end} scrollToEventId="event-1" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-xl-4">
                  <div className="card border-0 rounded-2 " style={{ marginTop: '2.5rem' }}>
                    {/* Solid Blue Header */}
                    <div className="bg-primary px-4 py-3 border-bottom border-white">
                      <h5 className="text-white mb-0">New Appointment</h5>
                    </div>
                    {/* Patterned Background Body */}
                    <div
                      className="card-body p-4"
                      style={{
                        backgroundImage: `url(${VectorBg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right bottom',
                        backgroundSize: 'cover',
                        backgroundColor: '#0D6EFD',
                        backgroundAttachment: 'local',
                        minHeight: '100%',
                      }}
                    >
                      <Formik
                        key={patientType}
                        initialValues={formData}
                        validationSchema={validationSchema}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                          const formattedSlot = convertSlotsTo24HourFormat(values.selectedTimeSlots);

                          // Get specialization either from direct selection or from selected doctor
                          let specializationId = values.specialization;
                          if (!specializationId) {
                            const selectedDoctor = doctors.find(doc => doc.id === values.doctorName);
                            specializationId = selectedDoctor?.specialization;
                          }

                          const self_reqbody = {
                            "doctor_id": values.doctorName,
                            "user_id": selectedUserId,
                            "appointment_date": values.appointmentDate,
                            "time_slots": formattedSlot,
                            "vendor_id": vendorId,
                            "service_id": serviceId,
                            "service_offering": specializationId, // Use the determined specialization
                            "appointment_type": patientType === "user" ? "self" : "dependent",
                            "insurance_provider": values.insuranceProvider,
                            "insurance_number": values.insuranceNumber,
                            ...((values.dependentId !== "" && values.dependentId !== undefined) && patientType !== "user" && { dependent_id: values.dependentId }),
                            ...((values.dependentId === "" || values.dependentId === undefined) && patientType !== "user" && {
                              dependent_name: values.patientName,
                              dependent_gender: values.gender === 'Male' ? 1 : 2,
                              dependent_mobile: values.mobileNumber,
                              dependent_dob: values.dob
                            }),
                            gender: values.gender === 'Male' ? 1 : 2,
                            ...(((values.age === "" || selectedUserId === null) && {
                              dob: values.dob
                            })),
                            ...((selectedUserId === null && {
                              first_name: values.patientName,
                              mobileNumber: values.mobileNumber,
                              // dob: values.dob
                            }))
                          };

                          handleBookAppointmentApi(self_reqbody);
                          setSubmitting(false);
                          resetForm();
                          fetchDoctors(vendorId);
                          setShowSpecializationDropdown(false);
                          setSpecializationSearchTerm("");
                          // Reset all related states
                          setShowTimeDropdown(false);
                          setAvailableTimeSlots([]);
                          setDoctorAvailability(null);
                          setFormData({
                            mobileNumber: '',
                            patientName: '',
                            age: '',
                            dob: '',
                            gender: '',
                            insuranceNumber: '',
                            insuranceProvider: '',
                            specialization: '',
                            doctorName: '',
                            appointmentDate: '',
                            selectedTimeSlots: []
                          });
                          setIsDetailsFetched(false);
                        }}
                      >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, resetForm, setFieldValue, setFieldTouched, setFieldError }) => {
                          const handleDoctorDropdownScroll = (e) => {
                            const { scrollTop, scrollHeight, clientHeight } = e.target;
                            if (scrollHeight - scrollTop <= clientHeight * 1.5) {
                              if (!isLoadingMoreDoctors && hasMoreDoctors) {
                                fetchDoctors(vendorId, values.specialization, doctorPage + 1, true, doctorSearchTerm);
                              }
                            }
                          };

                          return (
                            <form onSubmit={handleSubmit}>
                              <div className="mb-3">
                                <label className="form-labels text-white mb-2">Patient Type</label>
                                <div className="radio-group">
                                  <label className={`radio-label ${patientType === 'user' ? 'selected' : ''}`}>
                                    <input
                                      type="radio"
                                      name="patientType"
                                      value="user"
                                      checked={patientType === 'user'}
                                      onChange={handlePatientTypeChange}
                                      className="radio-input"
                                    />
                                    <span>User</span>
                                  </label>
                                  <label className={`radio-label ${patientType === 'dependent' ? 'selected' : ''}`}>
                                    <input
                                      type="radio"
                                      name="patientType"
                                      value="dependent"
                                      checked={patientType === 'dependent'}
                                      onChange={handlePatientTypeChange}
                                      className="radio-input"
                                    />
                                    <span>Dependent</span>
                                  </label>
                                </div>
                              </div>

                              <div className="mb-3">
                                <label className="form-labels text-white mb-2">Mobile Number</label>
                                <div className="position-relative">
                                  <div className="position-relative">
                                    <PhoneInput
                                      country={'ae'}
                                      onlyCountries={['ae', 'in']}
                                      value={values.mobileNumber}
                                      onChange={(value) => {
                                        const cleanedValue = value.replace(/\D/g, '');

                                        setFieldValue('mobileNumber', cleanedValue);
                                        setFieldTouched('mobileNumber', true, false); // Mark as touched immediately

                                        // Immediate validation on every keystroke
                                        if (cleanedValue.length > 0) {
                                          if (cleanedValue.startsWith('91')) {
                                            if (cleanedValue.length < 12) {
                                              setFieldError('mobileNumber', 'Please enter a valid Indian phone number (min 10 digits)');
                                            } else {
                                              setFieldError('mobileNumber', undefined);
                                              // Only fetch details when valid
                                              if (cleanedValue.length >= 12 && cleanedValue.length <= 15) {
                                                fetchPatientDetails(cleanedValue, setFieldValue);
                                              }
                                            }
                                          } else if (cleanedValue.startsWith('971')) {
                                            if (cleanedValue.length < 12) {
                                              setFieldError('mobileNumber', 'Please enter a valid UAE phone number (min 9 digits)');
                                            } else {
                                              setFieldError('mobileNumber', undefined);
                                              // Only fetch details when valid
                                              if (cleanedValue.length >= 12 && cleanedValue.length <= 15) {
                                                fetchPatientDetails(cleanedValue, setFieldValue);
                                              }
                                            }
                                          } else {
                                            setFieldError('mobileNumber', 'Please enter a valid phone number starting with 91 (India) or 971 (UAE)');
                                          }
                                        } else {
                                          setFieldError('mobileNumber', undefined);
                                        }
                                      }}
                                      onBlur={() => {
                                        setFieldTouched('mobileNumber', true, true);
                                        // Force validation check
                                        if (values.mobileNumber) {
                                          const cleanedValue = values.mobileNumber.replace(/\D/g, '');
                                          if (cleanedValue.startsWith('91') && cleanedValue.length < 12) {
                                            setFieldError('mobileNumber', 'Please enter a valid Indian phone number (min 10 digits)');
                                          } else if (cleanedValue.startsWith('971') && cleanedValue.length < 12) {
                                            setFieldError('mobileNumber', 'Please enter a valid UAE phone number (min 9 digits)');
                                          } else if (!cleanedValue.startsWith('91') && !cleanedValue.startsWith('971')) {
                                            setFieldError('mobileNumber', 'Please enter a valid phone number');
                                          } else {
                                            setFieldError('mobileNumber', undefined);
                                          }
                                        }
                                      }}
                                      inputStyle={{
                                        width: '100%',
                                        height: '40px',
                                        backgroundColor: 'white',
                                        borderColor: errors.mobileNumber ? '#dc3545' :
                                          values.mobileNumber && !errors.mobileNumber ? '#28a745' : '#ced4da',
                                        fontFamily: 'Poppins',
                                        fontWeight: 400,
                                        fontSize: '12px',
                                        lineHeight: '100%'
                                      }}
                                      inputProps={{
                                        name: 'mobileNumber',
                                        required: true,
                                        autoFocus: false
                                      }}
                                    />
                                    <button
                                      type="button"
                                      className="btn border-0 p-0 position-absolute end-0 top-50 translate-middle-y me-2 text-danger text-decoration-underline fs-6"
                                      onClick={() => fetchPatientDetails(values.mobileNumber, setFieldValue)}
                                      disabled={isFetchingPatient || !values.mobileNumber ||
                                        (values.mobileNumber.startsWith('91') && values.mobileNumber.length < 12) ||
                                        (values.mobileNumber.startsWith('971') && values.mobileNumber.length < 12) ||
                                        (!values.mobileNumber.startsWith('91') && !values.mobileNumber.startsWith('971'))}
                                      style={{ zIndex: 1 }}
                                    >
                                      {isFetchingPatient ? 'Fetching...' : 'Fetch Details'}
                                    </button>
                                  </div>
                                  {errors.mobileNumber && (
                                    <div className="invalid-feedbacks d-block text-white" style={{ fontSize: '12px', marginTop: '4px', color: '#ff6b6b' }}>
                                      {errors.mobileNumber}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {patientType === 'dependent' && showDependentDropdown && (
                                <div className="mb-3">
                                  <label className="form-labels text-white mb-2">Select Dependent</label>
                                  <div className="position-relative">
                                    <div
                                      className="w-100 bg-white rounded shadow-sm"
                                      style={{
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        border: '1px solid #dee2e6'
                                      }}
                                    >
                                      {dependents.length > 0 ? (
                                        <>
                                          {dependents.map((dependent) => (
                                            <div
                                              key={dependent.id}
                                              className="p-2 cursor-pointer hover-bg-light"
                                              style={{
                                                borderBottom: '1px solid #dee2e6',
                                                cursor: 'pointer'
                                              }}
                                              onClick={() => handleDependentSelect(dependent, setFieldValue)}
                                            >
                                              {dependent.name}
                                            </div>
                                          ))}
                                          <div
                                            className="p-2 cursor-pointer hover-bg-light text-primary"
                                            style={{
                                              borderBottom: '1px solid #dee2e6',
                                              cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                              setShowDependentDropdown(false);
                                              setFormData(prev => ({
                                                ...prev,
                                                patientName: '',
                                                age: '',
                                                gender: '',
                                                phoneNumber: ''
                                              }));
                                            }}
                                          >
                                            + Enter New Dependent Details
                                          </div>
                                        </>
                                      ) : (
                                        <div className="p-2 text-muted">
                                          No dependents found. Please enter new dependent details.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="mb-3">
                                <label className="form-labels text-white mb-2">Patient Name</label>
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    name="patientName"
                                    value={values.patientName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={`form-control form-input bg-white border-0 rounded ${touched.patientName && errors.patientName ? 'is-invalid' : ''}`}
                                    placeholder="Name"
                                    style={{ height: '40px' }}
                                    disabled={isDetailsFetched && patientType === 'user'}
                                  />
                                  {touched.patientName && errors.patientName && (
                                    <div className="invalid-feedbacks d-block text-white">{errors.patientName}</div>
                                  )}
                                </div>
                              </div>
                              {
                                ((selectedUserId !== null && patientType === "user" && values.age !== "") ||
                                  (patientType === "dependent" && dependents.length !== 0 && values.age !== ""))
                                  ? (
                                    <div className="mb-3">
                                      <label className="form-labels text-white mb-2">Age</label>
                                      <input
                                        type="text"
                                        name="age"
                                        value={values.age}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={`form-control form-input bg-white border-0 rounded ${touched.age && errors.age ? 'is-invalid' : ''}`}
                                        placeholder="Age"
                                        style={{ height: '40px' }}
                                      />
                                      {touched.age && errors.age && (
                                        <div className="invalid-feedbacks d-block text-white">{errors.age}</div>
                                      )}
                                    </div>
                                  ) : (
                                    <div className="mb-3 w-100">
                                      <label className="form-labels text-white mb-2">Date of birth</label>
                                      <div className="w-100 position-relative">
                                        <DatePicker
                                          selected={
                                            values.dob
                                              ? (() => {
                                                const [year, month, day] = values.dob.split('-');
                                                return new Date(year, month - 1, day); // Create date without timezone
                                              })()
                                              : null
                                          }
                                          onChange={(date) => {
                                            if (!date) {
                                              setFieldValue('dob', '');
                                              return;
                                            }

                                            // Format date without timezone considerations
                                            const year = date.getFullYear();
                                            const month = String(date.getMonth() + 1).padStart(2, '0');
                                            const day = String(date.getDate()).padStart(2, '0');
                                            const formattedDate = `${year}-${month}-${day}`;

                                            setFieldValue('dob', formattedDate);
                                          }}
                                          dateFormat="yyyy-MM-dd"
                                          className={`form-control form-input bg-white border-0 rounded w-100 ${touched.dob && errors.dob ? 'is-invalid' : ''}`}
                                          placeholderText="Date of birth"
                                          // Set maxDate to yesterday (not today)
                                          maxDate={(() => { const d = new Date(); d.setDate(d.getDate() - 1); d.setHours(0, 0, 0, 0); return d; })()}
                                          showYearDropdown
                                          scrollableYearDropdown
                                          yearDropdownItemNumber={100}
                                          adjustDateOnChange={false} // Prevent timezone adjustments
                                        />
                                        <IoCalendarOutline
                                          className="position-absolute end-1 top-50 translate-middle-y text-secondary pe-none text-dark"

                                          style={{
                                            right: errors.dob && touched.dob ? '1.75rem' : '0.75rem'

                                          }}
                                        />
                                      </div>
                                      {touched.dob && errors.dob && (
                                        <div className="invalid-feedbacks d-block text-white">{errors.dob}</div>
                                      )}
                                    </div>
                                  )
                              }

                              <div className="mb-3">

                                <label className="form-labels text-white mb-2">Gender</label>
                                <select
                                  name="gender"
                                  value={
                                    values.gender === null || values.gender === "" || values.gender === "Not Available"
                                      ? "Not Available"
                                      : values.gender
                                  }
                                  onChange={(e) => {
                                    const selected = e.target.value;
                                    handleChange({
                                      target: {
                                        name: 'gender',
                                        value: selected === "Not Available" ? null : selected
                                      }
                                    });
                                  }}
                                  onBlur={handleBlur}
                                  className={`form-select form-input bg-white border-0 rounded 
                                    ${values.gender === "" ? "placeholder-style" : ""} 
                                    ${touched.gender && errors.gender ? "is-invalid" : ""}`} style={{ height: '40px' }}
                                  disabled={false}
                                >
                                  <option value="">Select Gender</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                </select>
                                {touched.gender && errors.gender && (
                                  <div className="invalid-feedbacks d-block text-white">{errors.gender}</div>
                                )}
                              </div>

                              <div className="mb-3">
                                <label className="form-labels text-white mb-2">
                                  Insurance Number <span className="text-white-50">(Optional)</span>
                                </label>
                                <input
                                  type="text"
                                  name="insuranceNumber"
                                  value={values.insuranceNumber}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={`form-control form-input bg-white border-0 rounded ${touched.insuranceNumber && errors.insuranceNumber ? 'is-invalid' : ''}`}
                                  placeholder="Number"
                                  style={{ height: '40px' }}
                                />
                                {touched.insuranceNumber && errors.insuranceNumber && (
                                  <div className="invalid-feedbacks d-block text-white">{errors.insuranceNumber}</div>
                                )}
                              </div>

                              <div className="mb-3" style={{ position: "relative" }} ref={insuranceProviderRef}>
                                <label className="form-labels text-white mb-2">
                                  Insurance Provider <span className="text-white-50">(Optional)</span>
                                </label>

                                <div
                                  onClick={() => setShowInsuranceProviderDropdown(!showInsuranceProviderDropdown)}
                                  className={`label-dropdown-toggle form-input ${values.insuranceProvider === "" ? "placeholder-style" : ""}`}
                                  style={{ color: values.insuranceProvider ? "#000000" : "#898989" }}
                                >
                                  {insuranceProviders.find((p) => p.insurance_provider_id === values.insuranceProvider)?.name || "Select Insurance Provider"}
                                  <FaChevronDown className="text-dark" />
                                </div>

                                {showInsuranceProviderDropdown && (
                                  <div className="label-provider-dropdown">
                                    <div className="p-2" style={{ borderBottom: "1px solid #E9ECEF" }}>
                                      <input
                                        type="text"
                                        placeholder="Search"
                                        value={insuranceProviderSearchTerm}
                                        onChange={(e) => setInsuranceProviderSearchTerm(e.target.value)}
                                        className="form-input label-search-input"
                                      />
                                    </div>
                                    {insuranceProviders.length > 0 ? (
                                      insuranceProviders
                                        .filter((p) =>
                                          (p.name || "").toLowerCase().includes(insuranceProviderSearchTerm.toLowerCase())
                                        )
                                        .map((p) => (
                                          <div
                                            key={p.id}
                                            className="p-2 list-item"
                                            style={{
                                              background: values.insuranceProvider === p.id ? "#E3EBF8" : "white",
                                            }}
                                            onClick={() => {
                                              setFieldValue("insuranceProvider", p.insurance_provider_id);
                                              setShowInsuranceProviderDropdown(false);
                                              setInsuranceProviderSearchTerm("");
                                            }}
                                          >
                                            {p.name}
                                          </div>
                                        ))
                                    ) : (
                                      <div className="p-2 text-dark">Loading insurance providers...</div>
                                    )}
                                  </div>
                                )}
                                {touched.insuranceProvider && errors.insuranceProvider && (
                                  <div className="invalid-feedbacks d-block text-white">{errors.insuranceProvider}</div>
                                )}
                              </div>


                              <div className="mb-3" style={{ position: 'relative' }} ref={specializationRef}>
                                <label className="form-labels text-white mb-2">Specialization</label>
                                <div
                                  onClick={() => {
                                    setShowSpecializationDropdown(!showSpecializationDropdown);
                                    setDoctorDropdownOpen(false);
                                  }}
                                  className={`label-dropdown-toggle form-input ${values.specialization === "" ? "placeholder-style" : ""}`}
                                  style={{ color: values.specialization ? "#000000" : "#898989" }}
                                >
                                  {specializations.find((spec) => spec.id === values.specialization)?.name || "Select Specialization"}
                                  <FaChevronDown className="text-dark" />
                                </div>

                                {showSpecializationDropdown && (
                                  <div className="label-provider-dropdown">
                                    <div className="p-2" style={{ borderBottom: "1px solid #E9ECEF" }}>
                                      <input
                                        type="text"
                                        placeholder="Search specialization..."
                                        value={specializationSearchTerm}
                                        onChange={(e) => setSpecializationSearchTerm(e.target.value)}
                                        className="form-input label-search-input"
                                      />
                                    </div>
                                    {specializations
                                      .filter((spec) =>
                                        (spec.name || "").toLowerCase().includes(specializationSearchTerm.toLowerCase())
                                      )
                                      .map((spec) => (
                                        <div
                                          key={spec.id}
                                          className="p-2 list-item"
                                          style={{
                                            background: values.specialization === spec.id ? "#E3EBF8" : "white",
                                          }}
                                          onClick={() => {
                                            setFieldValue("specialization", spec.id);
                                            setFieldValue("doctorName", ""); // Clear doctor
                                            setShowSpecializationDropdown(false);
                                            setSpecializationSearchTerm("");
                                            if (spec.id) {
                                              fetchDoctors(vendorId, spec.id);
                                            } else {
                                              fetchDoctors(vendorId);
                                            }
                                          }}
                                        >
                                          {spec.name}
                                        </div>
                                      ))}
                                  </div>
                                )}
                                {touched.specialization && errors.specialization && (
                                  <div className="invalid-feedbacks d-block text-white">{errors.specialization}</div>
                                )}
                              </div>


                              <div className="mb-3" style={{ position: "relative" }} ref={doctorDropdownRef}>
                                <label className="form-labels text-white mb-2">
                                  {getServiceName("name")} Name
                                </label>
                                <div
                                  onClick={() => setDoctorDropdownOpen((prev) => !prev)}
                                  className={`label-dropdown-toggle form-input ${values.doctorName === "" ? "placeholder-style" : ""}`}
                                  style={{ color: values.doctorName ? "#000000" : "#898989" }}
                                >
                                  {doctors.length > 0
                                    ? (() => {
                                      const selectedDoctor = doctors.find((doc) => doc.id === values.doctorName);
                                      return selectedDoctor
                                        ? `${getServiceName("shortName")}. ${selectedDoctor.name.charAt(0).toUpperCase()}${selectedDoctor.name.slice(1).toLowerCase()}`
                                        : `Select ${getServiceName("name")}`;
                                    })()
                                    : `Select ${getServiceName("name")}`}
                                  <span style={{ marginLeft: "auto", color: "black" }}>
                                    <FaChevronDown />
                                  </span>
                                </div>

                                {doctorDropdownOpen && (
                                  <div className="label-provider-dropdown" onScroll={handleDoctorDropdownScroll}>
                                    <div className="p-2" style={{ borderBottom: "1px solid #E9ECEF" }}>
                                      <input
                                        type="text"
                                        placeholder="Search"
                                        value={doctorSearchTerm}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setDoctorSearchTerm(value);
                                          if (doctorSearchTimeout) {
                                            clearTimeout(doctorSearchTimeout);
                                          }
                                          const timeoutId = setTimeout(() => {
                                            setDoctorPage(1);
                                            setHasMoreDoctors(true);
                                            fetchDoctors(vendorId, values.specialization, 1, false, value);
                                          }, 500);
                                          setDoctorSearchTimeout(timeoutId);
                                        }}
                                        className="form-input label-search-input"
                                      />
                                    </div>
                                    {doctors.map((doc) => (
                                      <div
                                        key={doc.id}
                                        className="p-2 list-item"
                                        style={{
                                          background: values.doctorName === doc.id ? "#E3EBF8" : "white",
                                        }}
                                        onClick={() => {
                                          setFieldValue("doctorName", doc.id);
                                          fetchDoctorHolidays(doc.id);
                                          setDoctorDropdownOpen(false);
                                          setDoctorSearchTerm("");
                                        }}
                                      >
                                        {`${getServiceName("shortName")}. ${doc.name.charAt(0).toUpperCase()}${doc.name.slice(1).toLowerCase()}`}
                                      </div>
                                    ))}
                                    {isLoadingMoreDoctors && (
                                      <div className="p-2 text-center" style={{ borderBottom: "1px solid #E9ECEF" }}>
                                        Loading more doctors...
                                      </div>
                                    )}
                                    {!hasMoreDoctors && doctors.length > 0 && (
                                      <div className="p-2 text-center text-muted" style={{ fontSize: "12px" }}>
                                        No more doctors to load
                                      </div>
                                    )}
                                  </div>
                                )}
                                {touched.doctorName && errors.doctorName && (
                                  <div className="invalid-feedbacks d-block text-white">{errors.doctorName}</div>
                                )}
                              </div>


                              <div className="mb-3 d-flex gap-3">
                                <div style={{ flex: 1 }}>
                                  <label className="form-labels text-white mb-2">Date</label>
                                  <div className="position-relative">
                                    <DatePicker
                                      selected={
                                        values.appointmentDate
                                          ? (() => {
                                            const [year, month, day] = values.appointmentDate.split("-");
                                            return new Date(year, month - 1, day);
                                          })()
                                          : null
                                      }
                                      onChange={(date) => {
                                        if (!date) return;

                                        const year = date.getFullYear();
                                        const month = String(date.getMonth() + 1).padStart(2, "0");
                                        const day = String(date.getDate()).padStart(2, "0");
                                        const formattedDate = `${year}-${month}-${day}`;

                                        setFieldValue("appointmentDate", formattedDate);
                                        setFieldValue("selectedTimeSlots", []);
                                        setAvailableTimeSlots([]);

                                        if (values.doctorName) {
                                          fetchDoctorAvailability(values.doctorName, formattedDate);
                                        }
                                      }}
                                      minDate={new Date()}
                                      dateFormat="yyyy-MM-dd"
                                      excludeDates={
                                        holidaysDates?.map((dateStr) => {
                                          const [year, month, day] = dateStr.split("-");
                                          return new Date(year, month - 1, day);
                                        }) || []
                                      }
                                      filterDate={(date) => {
                                        const year = date.getFullYear();
                                        const month = String(date.getMonth() + 1).padStart(2, "0");
                                        const day = String(date.getDate()).padStart(2, "0");
                                        const dateString = `${year}-${month}-${day}`;
                                        return !holidaysDates?.includes(dateString);
                                      }}
                                      dayClassName={(date) => {
                                        const year = date.getFullYear();
                                        const month = String(date.getMonth() + 1).padStart(2, "0");
                                        const day = String(date.getDate()).padStart(2, "0");
                                        const dateString = `${year}-${month}-${day}`;
                                        return holidaysDates?.includes(dateString) ? "disabled-day" : null;
                                      }}
                                      className="form-control form-input bg-white border-0 rounded"

                                      placeholderText="Select date"
                                      style={{
                                        height: "40px",
                                        width: "100%",
                                        paddingRight: "30px",
                                        color: values.appointmentDate ? "#000000" : "#898989"
                                      }}
                                      adjustDateOnChange
                                      shouldCloseOnSelect={true}
                                      onSelect={(date) => {
                                        const year = date.getFullYear();
                                        const month = String(date.getMonth() + 1).padStart(2, "0");
                                        const day = String(date.getDate()).padStart(2, "0");
                                        setFieldValue("appointmentDate", `${year}-${month}-${day}`);
                                      }}
                                    />
                                    <IoCalendarOutline
                                      className="position-absolute end-1 top-50 translate-middle-y text-secondary pe-none text-dark"
                                      style={{
                                        right: errors.appointmentDate && touched.appointmentDate ? '0.75rem' : '0.75rem'
                                      }}
                                    />
                                  </div>
                                  {touched.appointmentDate && errors.appointmentDate && (
                                    <div className="invalid-feedbacks d-block text-white">{errors.appointmentDate}</div>
                                  )}
                                </div>

                                <div style={{ flex: 1 }} ref={timeSlotRef}>
                                  <label className="form-labels text-white mb-2">Time</label>
                                  <div style={timeSlotStyles.dropdownContainer}>
                                    <div
                                      style={{
                                        ...timeSlotStyles.timeInput,

                                      }}
                                      onClick={() => {
                                        if (values.doctorName && values.appointmentDate) {
                                          setShowTimeDropdown(!showTimeDropdown);
                                        } else {
                                          toast.warning("Please select both doctor and date first");
                                        }
                                      }}
                                      className={`form-input ${values.selectedTimeSlots.length === 0 ? "placeholder-style" : ""}`}
                                    >
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "inline-block",
                                          maxWidth: "100%",
                                          color: values.selectedTimeSlots.length === 0 ? "#898989" : "#000000",
                                        }}
                                      >
                                        {values.selectedTimeSlots.length === 0
                                          ? "Select Time"
                                          : `${values.selectedTimeSlots[0]} (${values.selectedTimeSlots.length} slot${values.selectedTimeSlots.length > 1 ? "s" : ""})`}
                                      </span>
                                      <FaRegClock className="text-dark" style={{ fontSize: "14px" }} />
                                    </div>

                                    {touched.selectedTimeSlots && errors.selectedTimeSlots && (
                                      <div className="invalid-feedbacks d-block text-white">
                                        {errors.selectedTimeSlots}
                                      </div>
                                    )}

                                    {showTimeDropdown && (
                                      <div style={timeSlotStyles.timeSlotList}>
                                        {isLoadingSlots ? (
                                          <div className="p-3 text-center" style={{ fontSize: "12px", color: "#6C757D" }}>
                                            Loading available slots...
                                          </div>
                                        ) : availableTimeSlots.length > 0 ? (
                                          <div style={chipGridStyles.grid}>
                                            {availableTimeSlots.map((slot, index) => {
                                              const startTime = slot.split("-")[0].trim();
                                              const isSelected = values.selectedTimeSlots.includes(startTime);
                                              return (
                                                <label
                                                  key={index}
                                                  htmlFor={`timeslot-${index}`}
                                                  style={{
                                                    ...chipGridStyles.chip,
                                                    ...(isSelected && chipGridStyles.chipSelected),
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    id={`timeslot-${index}`}
                                                    checked={isSelected}
                                                    onChange={() => {
                                                      const updated = [...values.selectedTimeSlots];
                                                      const i = updated.indexOf(startTime);
                                                      if (i === -1) updated.push(startTime);
                                                      else updated.splice(i, 1);
                                                      setFieldValue("selectedTimeSlots", updated);
                                                    }}
                                                    style={chipGridStyles.hiddenCheckbox}
                                                  />
                                                  {startTime}
                                                </label>
                                              );
                                            })}
                                          </div>
                                        ) : (
                                          <div className="p-3 text-center" style={{ fontSize: "12px", color: "#6C757D" }}>
                                            {values.appointmentDate && values.doctorName
                                              ? "No appointments available for selected date"
                                              : "Please select both doctor and date to view available slots"}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>

                              </div>


                              <div className="d-flex gap-2">
                                <button
                                  type="submit"
                                  className="btn btn-danger custom-btn btn-large flex-grow-1 "
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting ? 'Saving...' : 'Save'}
                                </button>
                                <button
                                  type="button"
                                  className="btn custom-btn btn-large bg-white flex-grow-1 "
                                  onClick={() => {
                                    resetForm();
                                    setFormData({
                                      mobileNumber: '',
                                      patientName: '',
                                      age: '',
                                      dob: '',
                                      gender: '',
                                      insuranceNumber: '',
                                      insuranceProvider: '',
                                      specialization: '',
                                      doctorName: '',
                                      appointmentDate: '',
                                      selectedTimeSlots: []
                                    });
                                    fetchDoctors(vendorId);
                                    setShowSpecializationDropdown(false);
                                    setSpecializationSearchTerm("");
                                  }}
                                >
                                  Cancel
                                </button>
                              </div>
                            </form>
                          );
                        }}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Appointment Sidebar Popup */}
          {selectedAppointment && (
            <>
              <div className="appointment-sidebar-overlay" onClick={() => handleCloseAppointment()}></div>
              <div className="appointment-sidebar-popup">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="mb-0">{appointmentMode === 'edit' ? 'Appointment' : 'Appointment'}</h5>
                  <button
                    className="btn btn-link p-0"
                    onClick={() => handleCloseAppointment()}
                    style={{ color: '#000' }}
                  >
                    <FaTimes />
                  </button>
                </div>

                <NewAppointment
                  initialData={selectedAppointment}
                  bookingId={selectedAppointment?.bookingId}
                  holidayDates={holidaysDates}
                  doctors={doctors}
                  callApi={fetchCalendardata}
                  timeSlots={availableTimeSlots}
                  mode={appointmentMode}
                  onClose={handleCloseAppointment}
                  refreshOverview={refreshOverviewTiles}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Dashboard;